/* eslint-disable prefer-promise-reject-errors */
import config from 'src/config';
import { postRequest } from 'src/utils/RequestUtil';

export const getAllPermissionsAPI = function (data) {
    const url = `${config.baseUrl}permissions/search`;
    return postRequest({
        url,
        data,
    });
};

export default {
    getAllPermissionsAPI,
};
